import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { getLanguage } from '../../../store/rootReducer';
import classNames from 'classnames';
import ValidationService from './ValidationService';
import './Password.scss'
import PasswordInputCtrl from './PasswordInputCtrl';
import PasswordRequirements from './PasswordRequirements';

class PasswordCreatorInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reqs: this.validateRequirements(""),
            contentsVisible: false,
            requirementsMet: false,
            hasValidated: false,
            value: ''
        };
    }
    
    validateRequirements = (pw) => {
        return {
            hasCapital: ValidationService.hasCapital(pw),
            hasLower: ValidationService.hasLower(pw),
            hasNum: ValidationService.hasNum(pw),
            hasChars: ValidationService.hasChars(pw),
            hasLength: ValidationService.hasLength(pw)
        };
    }

    requirementsMet = (reqs) => {
        var isValid = true
        for (var propName in reqs) {
            isValid &= reqs[propName]
        }
        return isValid;
    }

    onChange = (propertyName, value) => {
        var reqs = this.validateRequirements(value)
        var requirementsMet = this.requirementsMet(reqs)
        this.setState({
            reqs: reqs,
            value: value,
            requirementsMet
        })
        this.props.onChange(propertyName, value, requirementsMet)
    }

    onBlur = (propertyName) => {
        this.setState({ hasValidated: true });
        this.props.onBlur(propertyName)
    }

    toggleVisibility = () => {
        this.setState({ contentsVisible: !this.state.contentsVisible });
    }

    render() {
        var hasErrors = this.state.hasValidated && !this.state.requirementsMet
        return (
            <div className={classNames("hrb-pw-container", {
                "hrb-pw-container-with-errors": hasErrors
            })}>
                <div className="hrb-pw-left-side">
                    <PasswordInputCtrl {...this.props} reqs={this.state.reqs} propertyName={this.props.propertyName}
                        value={this.state.value} errorKey={hasErrors ? 'profile.password_info.errors.reqs_not_met' : null}
                        labelKey='profile.password_info.new_password' contentsVisible={this.state.contentsVisible}
                        onChange={this.onChange} onBlur={this.onBlur} toggleVisibility={this.toggleVisibility}
                        hideIndicator={true}
                    />
                </div>
                <div className="hrb-pw-right-side">
                    <PasswordRequirements reqs={this.state.reqs} labelKey='profile.password_info.pwf_req'
                        hasErrors={hasErrors}
                    />
                </div>
            </div>
        )
    }
}

PasswordCreatorInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired,
    propertyName: PropTypes.string.isRequired
}

const mapStateToProps = (state, ownProps) => {
    return {
        lang: getLanguage(state),
        ...ownProps
    }
};

export default connect(mapStateToProps)(PasswordCreatorInput);
